// extracted by mini-css-extract-plugin
module.exports = {"container":"_1GjOdJ0ymqhzEY_E7yb6vW","item":"_2rsSZ2V6_Dh096ZaLOIHYn","dot":"_1HgHDhcrk4yHHD5QH-E0gJ"};